import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'palantir-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class PalantirBreadcrumbsComponent {}
